import { FC } from "react";

import { MobileCampaignBannerView } from "@/canvas/features/FormV2/blocks/campaign-details/CampaignBanner/MobileCampaignBannerView";
import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";

export type MobileCampaignBannerProps = {
  useSquareRatioOnMobile?: boolean;
};

export const MobileCampaignBanner: FC<MobileCampaignBannerProps> = ({ useSquareRatioOnMobile = false }) => {
  const { formObject } = useFormV2Context();
  const isGhostPreview = useIsGhostPreview("FormV2Banner");

  if (formObject?.bannerUrl) {
    return (
      <MobileCampaignBannerView
        id={FORM_ELEMENT_IDS["banner"]}
        imageSrc={formObject.bannerUrl!}
        imageAlt={formObject.bannerAltText}
        videoSrc={undefined}
        data-test="banner-image"
        useSquareRatioOnMobile={useSquareRatioOnMobile}
        sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
      />
    );
  }

  if (formObject?.bannerVideoUrl) {
    return (
      <MobileCampaignBannerView
        id={FORM_ELEMENT_IDS["banner"]}
        videoSrc={formObject.bannerVideoUrl!}
        imageSrc={undefined}
        data-test="banner-video"
        useSquareRatioOnMobile={useSquareRatioOnMobile}
        sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
      />
    );
  }

  return null;
};
